'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _vLogo = require('./v-logo.png');

var _vLogo2 = _interopRequireDefault(_vLogo);

var _Tabs = require('./tabs/Tabs');

var _Tabs2 = _interopRequireDefault(_Tabs);

var _SideNavigation = require('./SideNavigation.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LOCAL = 'local';
var STAGING = 'staging';
var PRELIVE = 'prelive';
var NODE_ONE = 'node-one';
var NODE_TWO = 'node-two';
var PRODUCTION = 'production';

var VerticalHeader = function (_Component) {
  _inherits(VerticalHeader, _Component);

  function VerticalHeader(props) {
    _classCallCheck(this, VerticalHeader);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.fetchLayout = function () {
      var _this$props = _this.props,
          cdnUrl = _this$props.cdnUrl,
          env = _this$props.env;

      fetch(cdnUrl + '/config/layout.config.' + env + '.json?v=' + process.env.REACT_APP_LAYOUT_VERSION).then(function (response) {
        return response.json();
      }).then(function (config) {
        return _this.setState({
          isLoadingTabs: false,
          tabs: config
        });
      });
    };

    _this.toggoleExpantion = function (state) {
      _this.setState({
        isExpanded: state
      });
    };

    _this.state = {
      isLoadingTabs: true,
      tabs: {},
      isExpanded: false,
      language: _this.props.language
    };
    return _this;
  }

  VerticalHeader.prototype.componentDidMount = function componentDidMount() {
    this.fetchLayout();
  };

  VerticalHeader.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var language = props.language;


    if (language !== state.language) {
      return { language: language };
    }
    return null;
  };

  VerticalHeader.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var language = this.state.language;

    if (language !== prevProps.language) {
      this.fetchLayout();
    }
  };

  VerticalHeader.prototype.render = function render() {
    var _this2 = this;

    var isExpanded = this.state.isExpanded;
    var _props = this.props,
        mixpanel = _props.mixpanel,
        supportSingleLanguage = _props.supportSingleLanguage,
        user = _props.user,
        userRole = _props.userRole,
        language = _props.language;

    return _react2.default.createElement(
      _SideNavigation.SideNavigationContainer,
      { isExpanded: isExpanded },
      _react2.default.createElement(
        _SideNavigation.SideNavidationLogo,
        { alignItems: 'center', justifyContent: 'center', language: language },
        _react2.default.createElement('img', {
          src: _vLogo2.default,
          ref: function ref(img) {
            _this2.logo = img;
          },
          alt: 'logo',
          onClick: this.props.onLogoClick,
          onKeyDown: function onKeyDown() {}
        })
      ),
      _react2.default.createElement(_Tabs2.default, {
        activeTab: this.props.activeTab,
        isLoading: this.state.isLoadingTabs,
        tabs: this.state.tabs,
        toggoleExpantion: this.toggoleExpantion,
        language: this.props.language,
        supportSingleLanguage: supportSingleLanguage,
        user: user,
        mixpanel: mixpanel,
        userRole: userRole
      })
    );
  };

  return VerticalHeader;
}(_react.Component);

VerticalHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  onLogoClick: _propTypes2.default.func.isRequired,
  activeTab: _propTypes2.default.string.isRequired,
  env: _propTypes2.default.oneOf([LOCAL, STAGING, PRELIVE, NODE_ONE, NODE_TWO, PRODUCTION]),
  cdnUrl: _propTypes2.default.string.isRequired,
  language: _propTypes2.default.string.isRequired,
  supportSingleLanguage: _propTypes2.default.bool.isRequired,
  user: _propTypes2.default.object.isRequired,
  mixpanel: _propTypes2.default.object.isRequired,
  userRole: _propTypes2.default.string.isRequired
} : {};

VerticalHeader.defaultProps = {
  env: LOCAL
};

exports.default = VerticalHeader;
module.exports = exports['default'];